<template>
      <router-view/>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  data: () => ({

  }),
  created() {

  },
  computed: {
    ...mapGetters([
      'isAuth',
    ]),

    title() {
      return this.$route.meta.name;
    },
    isMain() {
      return this.$route.meta.main_page;
    }
  },
  methods: {
    prevPage() {
      this.$router.go(-1)
    },
  },
}
</script>
